import { isDefined } from '@sgme/fp';
import { ToggleButton } from '@sgme/ui';
import { Layout } from 'components/missed-deal-feedback/components/layout';
import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { useIntl } from 'react-intl';
import { FormIdProps } from 'shared/props';
import { getIsWithAdditionalInformation } from 'state/missed-deal-feeedback/selectors';
import { missedDealFeedbackSetWithAdditionalInformationThunk } from 'state/missed-deal-feeedback/thunk';

export function WithAdditionalInformation({ formId }: FormIdProps) {
  const { formatMessage } = useIntl();
  const dispatch = useThunkDispatch();
  const isWithAdditionalInformation = useAppSelector(s => getIsWithAdditionalInformation(s, formId));

  return (
    <Layout.Block>
      <ToggleButton
        options={[
          { value: 'yes', label: formatMessage({ id: 'missedDealFeedback.additionalInformationLabel.yes' }) },
          { value: 'no', label: formatMessage({ id: 'missedDealFeedback.additionalInformationLabel.no' }) },
        ]}
        values={isDefined(isWithAdditionalInformation) ? [isWithAdditionalInformation === false ? 'yes' : 'no'] : []}
        withIcon={false}
        multiple={false}
        onChange={values =>
          dispatch(
            missedDealFeedbackSetWithAdditionalInformationThunk(
              formId,
              values.some(v => v === 'no'),
            ),
          )
        }
      />
    </Layout.Block>
  );
}
